import { render } from "./TokensPage.vue?vue&type=template&id=b2543040"
import script from "./TokensPage.vue?vue&type=script&lang=js"
export * from "./TokensPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__